import React from 'react'
import cn from 'classnames'

import Text from './Text'
import News from './News'
import styles from './Products.module.css'

export default () => (
  <div className={styles.container}>
    <div className={cn(styles.header, 'reveal')}>
      <h4>Our products</h4>
    </div>

    <div className={styles.content}>
      <div className={styles.services}>
        <div className={styles.sections}>
          <div className={cn(styles.section, 'reveal-service')}>
            <div className={cn(styles.product, styles.barbro)}></div>
            <Text size="medium">
              <b>Let’s call it a comeback</b> for smooth and simple customer communication through phone, contact forms and more. In early 2019 we aim to launch a fully self founded product that we chose to name Barbro.
            </Text>
            <News to="https://barbro.com" style="inline">
              <span>Read more and sign up for <b>beta access</b></span>
            </News>
          </div>

          <div className={cn(styles.section, 'reveal-service')}>
            <div className={cn(styles.product, styles.podspace)}></div>
            <Text size="medium"><b>Podcasts sounds better in space</b> might be to over exaggerate things and surely podcast hosting is not rocket sience. But great software and running a reliable service is, thats why we made Podspace.</Text>
            <Text size="medium">In closed beta during 2018 and public launch in 2019.</Text>
            <News to="https://m.me/madebybowtie" style="inline">
              <span>Let us know if you want to <b>know more</b></span>
            </News>
          </div>
        </div>
      </div>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/Products.js